// @flow
import {List, ListItem} from "material-ui/List"
import {Route, Switch, withRouter, Link} from "react-router-dom"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import {CardText} from "material-ui/Card"
import {containers} from "@swarm2/core"
import Close from "material-ui/svg-icons/navigation/close"
import ContentAdd from "material-ui/svg-icons/content/add"
import Delete from "material-ui/svg-icons/action/delete"
import IconButton from "material-ui/IconButton"
import * as React from "react"
import * as Util from "../common"

const M = Util.intlMessages("view.CharacterList")
const LM = Util.intlMessages("leagues")

function DeleteCharacterListEntryRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {displayName, updatedAt, league, delete: deleteCharacter} = props
  const onDeleteConfirm = () => {
    window.confirm(
      // TODO i18n
      "Are you sure you want to delete this character? No undo. No reset-rewards.",
    ) && deleteCharacter()
  }
  return (
    <ListItem
      primaryText={displayName}
      secondaryText={
        <span style={{color: "inherit"}}>
          <div>
            Played <Util.FromNow since={updatedAt} />
          </div>
          <div>
            <LM id={league.split("-")[0]} />
          </div>
        </span>
      }
      leftIcon={<Delete />}
      onClick={onDeleteConfirm}
    />
  )
}
const DeleteCharacterListEntry = containers.characters.CharacterListItem(
  DeleteCharacterListEntryRender,
)

export function DeleteCharacterListRender(props: *) {
  if (props.isError) return <Util.Error error={props} />
  const {chars, user} = props
  const {displayName} = user
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
        </ToolbarGroup>
        <ToolbarGroup>
          <Util.PlainLink to={"/me/characters"}>
            <IconButton>
              <Close />
            </IconButton>
          </Util.PlainLink>
        </ToolbarGroup>
      </Toolbar>
      {chars && chars.length ? (
        <List>
          {chars.map(charId => (
            <DeleteCharacterListEntry key={charId} charId={charId} />
          ))}
        </List>
      ) : (
        <CardText>
          <M id="auth.nocharacters" values={{icon: <ContentAdd />}} />
        </CardText>
      )}
    </div>
  )
}
export const DeleteCharacterList = containers.characters.AuthCharacterList(
  DeleteCharacterListRender,
)

function AuthCharacterListEntryRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {charId, displayName, updatedAt, league} = props
  return (
    <Util.PlainLink to={"/p/" + charId}>
      <ListItem
        primaryText={displayName}
        secondaryText={
          <span style={{color: "inherit"}}>
            <div>
              <M
                id="since"
                values={{since: <Util.FromNow since={updatedAt} />}}
              />
            </div>
            <div>
              {/* for prerelease leagues */}
              <LM id={league.split("-")[0]} />
            </div>
          </span>
        }
      />
    </Util.PlainLink>
  )
}
const AuthCharacterListEntry = containers.characters.CharacterListItem(
  AuthCharacterListEntryRender,
)

export function AuthCharacterListRender(props: *) {
  if (props.isError) return <Util.Error error={props} />
  const {chars, limit, user} = props
  const {displayName} = user
  const disabled = !(!chars || chars.length < limit)
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
          {disabled ? (
            <IconButton disabled={disabled}>
              <ContentAdd />
            </IconButton>
          ) : (
            <Link to={"/me/characters/new"}>
              <IconButton disabled={disabled}>
                <ContentAdd />
              </IconButton>
            </Link>
          )}
        </ToolbarGroup>
        <ToolbarGroup>
          <Util.PlainLink to={"/me/characters/delete"}>
            <IconButton>
              <Delete />
            </IconButton>
          </Util.PlainLink>
        </ToolbarGroup>
      </Toolbar>
      {chars && chars.length ? (
        <List>
          {chars.map(charId => (
            <AuthCharacterListEntry key={charId} charId={charId} />
          ))}
        </List>
      ) : (
        <CardText>
          <M id="auth.nocharacters" values={{icon: <ContentAdd />}} />
        </CardText>
      )}
    </div>
  )
}
export const AuthCharacterList = containers.characters.AuthCharacterList(
  AuthCharacterListRender,
)

export const AuthCharacterListView = withRouter(props => {
  // Delete-mode gets a separate URL.
  // TODO: dropdown with 'delete' button next to each char; remove delete mode.
  return (
    <Switch>
      <Route exact path={props.match.path} component={AuthCharacterList} />
      <Route
        exact
        path={props.match.path + "/delete"}
        component={DeleteCharacterList}
      />
      <Route render={Util.NotFoundView} />
    </Switch>
  )
})

function CharacterListEntryRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {charId, displayName, updatedAt, league} = props
  return (
    <Util.PlainLink to={"/c/" + charId}>
      <ListItem
        primaryText={displayName}
        secondaryText={
          <span style={{color: "inherit"}}>
            <div>
              <M
                id="since"
                values={{since: <Util.FromNow since={updatedAt} />}}
              />
            </div>
            <div>
              <LM id={league.split("-")[0]} />
            </div>
          </span>
        }
      />
    </Util.PlainLink>
  )
}
export const CharacterListEntry = containers.characters.CharacterListItem(
  CharacterListEntryRender,
)

function CharacterListRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {chars, user} = props
  const {displayName} = user
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" values={{displayName}} />} />
        </ToolbarGroup>
      </Toolbar>
      {chars && chars.length ? (
        <List>
          {chars.map(charId => (
            <CharacterListEntry key={charId} charId={charId} />
          ))}
        </List>
      ) : (
        <CardText>
          <M id="noauth.nocharacters" values={{displayName}} />
        </CardText>
      )}
    </div>
  )
}
export const CharacterListView = containers.characters.CharacterList(
  Util.DumpProps(CharacterListRender),
)



// WEBPACK FOOTER //
// ./src/characters/CharacterListView.js